import type { AppProps } from '@interhyp/module-repayment-calculator';

import type { LoadModuleArgs } from '../../loader/loadModule.js';
import loadModule from '../../loader/loadModule.js';

import { RepaymentCalculatorPresets } from './RepaymentCalculatorPresets.js';

export type RepaymentCalculatorPresetProps = Omit<AppProps, 'content' | 'formErrors'>;

export interface LoadModuleRepaymentCalculatorArgs<T extends keyof RepaymentCalculatorPresets> {
  shell: Pick<LoadModuleArgs, 'tealium' | 'container'>;
  props: RepaymentCalculatorPresetProps;
  preset: (presets: RepaymentCalculatorPresets) => ReturnType<RepaymentCalculatorPresets[T]>;
}

export const loadModuleRepaymentCalculator = async <T extends keyof RepaymentCalculatorPresets>({
  shell,
  props,
  preset,
}: LoadModuleRepaymentCalculatorArgs<T>) => {
  const value = preset(RepaymentCalculatorPresets);

  return loadModule({
    url: '/frontend-modules/module-calculators/remoteEntry.js',
    name: {
      scope: 'module_calculators',
      specifier: './ModuleRepaymentCalculator',
    },
    ...shell,
    props: {
      ...props,
      ...value,
    },
  });
};
